var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DateTimePicker as MuiDateTimePicker, } from '@mui/x-date-pickers/DateTimePicker';
import React, { useCallback, useMemo } from 'react';
import { DatePickerSlots } from '../DatePicker/DatePicker';
import { DateTimePickerLayout } from './DateTimePickerLayout';
import { DateTimeField } from './DateTimeField';
/**
 * Custom components for DateTimePicker.
 * See [DateTimePicker API](https://mui.com/x/api/date-pickers/date-time-picker/#slots) for more details.
 */
export var DateTimePickerSlots = __assign(__assign({}, DatePickerSlots), { field: DateTimeField, toolbar: function () { return null; }, digitalClockSectionItem: function () { return null; }, layout: DateTimePickerLayout });
export function DateTimePicker(props) {
    var dayOfWeekFormatterDefault = useCallback(function (day) { return day.charAt(0).toUpperCase() + day.charAt(1); }, []);
    // Default views for dateTimePicker are aligned with older version of DateTimePicker.
    // This is to keep the same behavior as before.
    var getDefaultViews = useCallback(function (showSeconds) {
        var base = ['month', 'year', 'day', 'hours', 'minutes'];
        if (showSeconds) {
            base.push('seconds');
        }
        return base;
    }, []);
    var memoSlotProps = useMemo(function () {
        return __assign(__assign({ actionBar: {
                actions: ['cancel', 'accept'],
            } }, props === null || props === void 0 ? void 0 : props.slotProps), { layout: {
                minutesStep: (props === null || props === void 0 ? void 0 : props.minutesStep) || 1,
                secondsStep: (props === null || props === void 0 ? void 0 : props.secondsStep) || 1,
                showSeconds: (props === null || props === void 0 ? void 0 : props.showSeconds) || false,
            } });
    }, [props === null || props === void 0 ? void 0 : props.slotProps, props === null || props === void 0 ? void 0 : props.showSeconds, props === null || props === void 0 ? void 0 : props.minutesStep, props === null || props === void 0 ? void 0 : props.secondsStep]);
    var memoSlots = useMemo(function () { return (__assign(__assign({}, props === null || props === void 0 ? void 0 : props.slots), DateTimePickerSlots)); }, [props === null || props === void 0 ? void 0 : props.slots]);
    return (React.createElement(MuiDateTimePicker, __assign({ 
        // Default is to not close on select and wait for confirmation.
        closeOnSelect: false, views: getDefaultViews(props === null || props === void 0 ? void 0 : props.showSeconds), openTo: "day", dayOfWeekFormatter: dayOfWeekFormatterDefault, 
        // TODO: Find a better way how to hide MUI TimeClockView
        desktopModeMediaQuery: "(min-width: 1px)" }, props, { slots: memoSlots, slotProps: memoSlotProps })));
}
export default DateTimePicker;
